import { useContext } from 'react';
import UserPlanContext from '../contexts/UserPlanContext';

/**
 * Hook para acessar dados do plano do usuário.
 * Consome o UserPlanContext (estado compartilhado, uma única chamada à API).
 *
 * Deve ser usado dentro de um <UserPlanProvider>.
 */
export const useUserPlan = () => {
  const context = useContext(UserPlanContext);
  if (!context) {
    throw new Error(
      'useUserPlan deve ser usado dentro de um <UserPlanProvider>. ' +
      'Verifique se o App.js envolve as rotas protegidas com <UserPlanProvider>.'
    );
  }
  return context;
};
